import * as React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getTranslator } from '../Translator';
import { ElectionState } from '../_generatedTypes.g';
import { QuestionMark } from './ui/QuestionMark';
import { FilterList } from './ui/FilterList';
import { ContactInstitution } from './ContactInstitution';
import { CreateElectionPane } from './home/CreateElectionPane';
import { ElectionItem } from './election/ElectionItem';
import { electionSearched } from '../features/search/searchSlice';
import { createElectionSidePanelToggled } from '../features/home/homeSlice';
import { useAppSelector } from '../hooks';

export const Home = () => {
    const dispatch = useDispatch();

    const language = useAppSelector(state => state.language);
    const t = getTranslator(language);

    const elections = useAppSelector(state => state.elections);
    const isAdmin = useAppSelector(state => state.clientState.Account.IsAdmin);

    const searchTermElection = useAppSelector(state => state.searchItemState.SearchTermElection);
    const contactMailLink = useAppSelector(state => state.clientState.ContactMailLink);
    const sidePanelVisible = useAppSelector(state => state.homeScreen.sideMenuVisible);
    const justAddedCode = useAppSelector(state => state.homeScreen.justAddedCode);

    const addElectionButton = isAdmin && <p className="home__addbutton">
        <button onClick={() => dispatch(createElectionSidePanelToggled())}>{t['Add']}…</button>
    </p>;

    return <div id="Home-Component">
        {elections.length > 0
            ? <div>
                <QuestionMark>
                    <div className="popup-help">
                        <h2>{t.translate({ NL: 'Kandidaatstelling/verkiezing vullen:', EN: 'Fill in your candidacy/election form:' })}</h2>
                        <p>{t.translate({ NL: 'Klik op de verkiezing waarvoor je je kandidaat wilt stellen.', EN: 'Click on the election you want to run for.' })}</p>
                        <h2>{t.translate({ NL: 'Stemmen:', EN: 'Vote' })}</h2>
                        <p>{t.translate({ NL: 'Klik op de verkiezing waarvoor je je stem wilt uitbrengen.', EN: 'Click on the election in which you want to vote.' })}</p>
                    </div>
                </QuestionMark>
                <h1>{t['The elections visible to you are']}</h1>
                {addElectionButton}
                <FilterList<ElectionState>
                    searchTerm={searchTermElection}
                    onChange={v => dispatch(electionSearched(v))}
                    items={elections}
                    filter={(election, searchTerm) => t.translate(election.Name).toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1}
                    render={(election) => <ElectionItem election={election} key={election.Code} withAdminOptions={isAdmin} justAddedCode={justAddedCode} />}
                    label={t['Search election']}
                    language={t.languageCode}
                    className="home__elections"
                    minItemCountForFilter={10}
                />
            </div>
            : <p>{t['There are no elections open right now for which you have voting right.']}
                {addElectionButton}
                {contactMailLink && <span>
                    <a href={contactMailLink}>{t['If you believe this to be incorrect, please contact us.']}</a>
                </span>}
            </p>
        }
        <div>
            <p>{t['Do you have questions about the elections?']}</p>
            <ContactInstitution title={'Contact us via'} />
        </div>
        {isAdmin && <>
            <p><Link to="/admin">{t['Admin functionality']}</Link></p>
            <CreateElectionPane visible={sidePanelVisible} />
        </>}
    </div>
};
